import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import PaymentBody from 'components/payment/PaymentBody';
import paths from 'router/paths';

export const PaymentFail = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Purchase RC-Coin</title>
                <meta name='description' content='Purchase RC-Coin fail' />
            </Helmet>
            <PaymentBody
                backgroundImageUrl='lutador_shop_main.webp'
                description={`O pagamento falhou.\n Se o problema persistir, entre em contato com o suporte ao cliente.`}
                buttonText='Entrar em contato'
                link={paths.SUPPORT_PATH}
            />
        </>
    );
};
